import React from 'react'
import AdmStudentClass from '../../components/AdminTabs/AdminStudentClass/AdmStudentClass'

const StudentClass = () => {
  return (
    <div>
      <AdmStudentClass />
    </div>
  )
}

export default StudentClass
